import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AvatarModule } from '../avatar/avatar.module';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ConfirmationDialog } from './confirmation-dialog.component';

@NgModule({
  declarations: [
    ConfirmationDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    AvatarModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ConfirmationDialog
  ]
})
export class ConfirmationDialogModule { }
